import Typography from "components/typography";
import LinkText from "components/typography/linkText";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const SyncRequirements = () => {
  return (
    <Body>
      <Typography weight="semibold" color="white" mb="1.2" m_size="s">
        How To Sync Lyrics
      </Typography>

      <List>
        <li>
          <Typography size="s">
            Hit the play button at the bottom of the page
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Click the “Down Arrow” button on your screen or keyboard to adjust
            the timing to align with the first sung note of each line, or
            slightly less than half a second before.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Correct errors by using the “Up Arrow” button on your screen or
            keyboard to return to previous lines where you’ll then be able to
            re-sync 
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Verify the accuracy by playing each line and make any time
            adjustments with the “plus (+)” or “minus (-)” buttons
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            If there are no lyrics for more than 5 seconds, insert the
            "#INSTRUMENTAL" label and sync it with the timing.
          </Typography>
        </li>
      </List>
    </Body>
  );
};

export default SyncRequirements;

const Body = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  margin-bottom: 2.4rem;
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  margin-left: 1.2rem;
  color: ${Colors.grey500};

  li {
    margin-bottom: 0.8rem;
  }
`;
